import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { RegistrationDraftState, versionNumberState } from "../models/zustand.model";

import packageInfo from "../../package.json";

/**
 * The registration wizard's entire state, in one store.
 *
 * One store with one `reset()` means there is no longer a field you can forget
 * to clear — the previous split across three stores left the owner name behind
 * after a successful registration, so it carried into the next one.
 *
 * Persisted to sessionStorage so a mid-wizard refresh resumes instead of
 * silently emptying the draft. sessionStorage rather than localStorage: an
 * installer registers many devices in a sitting, but a half-finished draft
 * should not resurface days later in another tab.
 */
export const RegistrationDraftStore = create<RegistrationDraftState>()(
  persist(
    (set) => ({
      artomeSerialNo: "",
      epsonSerialNo: "",
      productName: "",
      ownerCompanyName: "",
      setArtomeSerial: (artomeSerialNo, productName) =>
        set(() => ({ artomeSerialNo, productName })),
      setEpsonSerial: (epsonSerialNo) => set(() => ({ epsonSerialNo })),
      setOwnerCompanyName: (ownerCompanyName) =>
        set(() => ({ ownerCompanyName })),
      reset: () =>
        set(() => ({
          artomeSerialNo: "",
          epsonSerialNo: "",
          productName: "",
          ownerCompanyName: "",
        })),
    }),
    {
      name: "artome-registration-draft",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export const AppVersionStore = create<versionNumberState>(() => ({
  version: packageInfo.version,
}));
